import api from "./Api";

class ClienteTelefoneService {
  GetClienteTelefone(payload) {
    return api.get("/v1/clienteTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostClienteTelefone(payload) {
    return api.post("/v1/clienteTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutClienteTelefone(payload) {
    return api.put("/v1/clienteTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteClienteTelefone(payload) {
    return api.delete("/v1/clienteTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetClienteTelefoneOData(payload) {
    return api.get("/OData/ClienteTelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ClienteTelefoneService();
